export default __webpack_public_path__ + "static/media/ce35dae1dc0b91ee3169bfa58924a2e81602168353845.1fbefda2.webp";